import { render, staticRenderFns } from "./AssigneesSelectorForm.vue?vue&type=template&id=8caa0ffe"
import script from "./AssigneesSelectorForm.vue?vue&type=script&lang=js"
export * from "./AssigneesSelectorForm.vue?vue&type=script&lang=js"
import style0 from "./AssigneesSelectorForm.vue?vue&type=style&index=0&id=8caa0ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports